import { CodeUoM } from '../../entities/shared/uom';
import { InvoiceLine } from '../../entities/invoicing/invoicing';
import { PriceBook, PriceListMode } from '../../entities/price.book';

export interface PriceBookCopyRequest {
    copyId: string;
    sourceId
    priceBook: PriceBook;
}

export interface CodeUoMPriceRequest {
    _id: string;
    codeName: string;
    codeUoM: CodeUoM;

}

export interface CodesPricesRequest {
    codes: CodeUoMPriceRequest[];
    sellPriceBookId: string;
    buyPriceBookId: string;
    technicianId: string;
    type?: CodePriceRequestType; // if !type, get price for both sell and buy
    workOrderId?: string;
    siteId?: string; // For site-based pricing lookup (used when workOrderId is not available, e.g., new job creation)
}

export interface LinesRequest {
    codes: InvoiceLine[];
    buyPriceBookId?: string;
    sellPriceBookId?: string;
    technicianId?: string;
}

export enum CodePriceRequestType {
    BuyPrice = 'BuyPrice',
    SellPrice = 'SellPrice'
}

export interface PricelistCopyRequest {
    sourceId: string;
    sourceMode: PriceListMode;
    newPricelist: PriceBook;
    includeSitePricing?: boolean;
}